import Vue from 'vue'
import Axios from 'axios'
import Qs from 'qs'

// Full config:  https://github.com/axios/axios#request-config
const axios = Axios.create({
  baseURL: '/newsapi',
  paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'brackets' }),
  withCredentials: true
})

axios.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
)

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    // 默认后台返回参数
    // {
    //   code: 0/..., 0为正确，其他为错误
    //   msg: '错误信息'  错误时msg为报错信息
    //   ...
    // }
    if (response.data.code === 0) {
      return Promise.resolve(response.data)
    }
    // TODO 改成接口需要放出reject 关闭resolve
    // return Promise.reject(new Error(response.data.msg))
    return Promise.resolve(response.data)
  },
  (error) => Promise.reject(error)

)

Vue.prototype.$axios = axios

export default axios
